import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./UsersTab.module.css";

export default function UsersTab() {
  const [users, setUsers] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [totalPages, setTotalPages] = useState(1);

  const load = () => {
    const token = localStorage.getItem("bni_token");
    axios
      .get(
        (process.env.REACT_APP_API_URL || "http://localhost:8080") +
          `/api/admin/users?page=${page}&pageSize=${pageSize}`,
        { headers: { Authorization: "Bearer " + token } }
      )
      .then((r) => {
        setUsers(r.data.data);
        setTotalPages(r.data.pagination.totalPages);
      })
      .catch((error) => {
        console.log("error while getting Members detail", error);
      });
  };

  useEffect(() => {
    load();
  }, [page]);

  const approve = async (id: string) => {
    const token = localStorage.getItem("bni_token");

    try {
      await axios.post(
        (process.env.REACT_APP_API_URL || "http://localhost:8080") +
          "/api/auth/approve/" +
          id,
        {},
        { headers: { Authorization: "Bearer " + token } }
      );
      load();
    } catch (error) {
      console.log("error while approving Member", error);
    }
  };

  return (
    <div>
      <h2 className={styles.title}>User Management</h2>

      <table className={styles.table}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u._id}>
              <td>{u.name}</td>
              <td>{u.email}</td>
              <td>{u.role}</td>
              <td>
                {u.role === "USER" && (
                  <button className={styles.btn} onClick={() => approve(u._id)}>
                    Approve → Member
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ✅ Pagination */}
      <div className={styles.pagination}>
        <button onClick={() => setPage(page - 1)} disabled={page === 1}>
          Prev
        </button>

        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            onClick={() => setPage(i + 1)}
            className={page === i + 1 ? styles.active : ""}
          >
            {i + 1}
          </button>
        ))}

        <button
          onClick={() => setPage(page + 1)}
          disabled={page === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
}
